import { z } from 'zod';
import { MAX_RETRY_DELAY_SECONDS } from './webhook-webhook-5';
export const MAX_REQUEST_TIMEOUT_SECONDS = {
    toolCall: 30,
    postCall: 30 // (maxRetries+1) * maxTimeout + maxRetries*maxRetryDelay = 11*T + 10*30 <= ? assume maxTimeout=60 (default=30), then set ? = 16m
};
export const createWebhook_Webhook_7_ConfigValidator = (isToolCall) => {
    const maxDelay = isToolCall ? MAX_RETRY_DELAY_SECONDS.toolCall : MAX_RETRY_DELAY_SECONDS.postCall;
    const maxTimeout = isToolCall ? MAX_REQUEST_TIMEOUT_SECONDS.toolCall : MAX_REQUEST_TIMEOUT_SECONDS.postCall;
    return z
        .object({
        connectionMode: z.enum(['custom', 'connection', 'group']),
        url: z.string().optional(),
        webhookConnectionId: z.string().optional(),
        connectionGroupId: z.string().optional(),
        path: z.string().optional(),
        requestMethod: z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH']).default('POST'),
        headers: z.record(z.string(), z.string()).optional(),
        payload: z.record(z.string(), z.any()).optional(),
        expectedOutput: z
            .string()
            .optional()
            .refine((val) => {
            if (!val || val === '')
                return true;
            try {
                JSON.parse(val);
                return true;
            }
            catch {
                return false;
            }
        }, {
            error: 'Must be empty string or valid JSON'
        }),
        retryEnabled: z.boolean().optional().default(false),
        maxRetries: z.number().min(1).max(10).optional().default(3),
        retryDelaySeconds: z.number().min(1).max(maxDelay).optional().default(5),
        requestTimeoutSeconds: z.number().min(1).max(maxTimeout).optional().default(30)
    })
        .refine((data) => {
        if (data.connectionMode === 'custom')
            return !!data.url;
        if (data.connectionMode === 'connection')
            return !!data.webhookConnectionId;
        if (data.connectionMode === 'group')
            return !!data.connectionGroupId;
        return true;
    }, {
        message: 'URL is required for custom mode, connection is required for connection mode, group is required for group mode'
    });
};
// Default export for post-call context
export const Webhook_Webhook_7_ConfigValidator = createWebhook_Webhook_7_ConfigValidator(false);
//# sourceMappingURL=webhook-webhook-7.js.map